import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { LinearFilter, MeshBasicMaterial, NearestFilter, RGBAFormat, ShaderMaterial, UniformsUtils, WebGLRenderTarget } from 'three';
import { Pass, FullScreenQuad } from '../postprocessing/Pass.js';
import { AfterimageShader } from '../shaders/AfterimageShader.js';

var AfterimagePass = /*#__PURE__*/function (_Pass) {
  _inherits(AfterimagePass, _Pass);

  var _super = _createSuper(AfterimagePass);

  function AfterimagePass() {
    var _this;

    var damp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.96;

    _classCallCheck(this, AfterimagePass);

    _this = _super.call(this);
    if (AfterimageShader === undefined) console.error('THREE.AfterimagePass relies on AfterimageShader');
    _this.shader = AfterimageShader;
    _this.uniforms = UniformsUtils.clone(_this.shader.uniforms);
    _this.uniforms['damp'].value = damp;
    _this.textureComp = new WebGLRenderTarget(window.innerWidth, window.innerHeight, {
      minFilter: LinearFilter,
      magFilter: NearestFilter,
      format: RGBAFormat
    });
    _this.textureOld = new WebGLRenderTarget(window.innerWidth, window.innerHeight, {
      minFilter: LinearFilter,
      magFilter: NearestFilter,
      format: RGBAFormat
    });
    _this.shaderMaterial = new ShaderMaterial({
      uniforms: _this.uniforms,
      vertexShader: _this.shader.vertexShader,
      fragmentShader: _this.shader.fragmentShader
    });
    _this.compFsQuad = new FullScreenQuad(_this.shaderMaterial);
    var material = new MeshBasicMaterial();
    _this.copyFsQuad = new FullScreenQuad(material);
    return _this;
  }

  _createClass(AfterimagePass, [{
    key: "render",
    value: function render(renderer, writeBuffer, readBuffer
    /*, deltaTime, maskActive*/
    ) {
      this.uniforms['tOld'].value = this.textureOld.texture;
      this.uniforms['tNew'].value = readBuffer.texture;
      renderer.setRenderTarget(this.textureComp);
      this.compFsQuad.render(renderer);
      this.copyFsQuad.material.map = this.textureComp.texture;

      if (this.renderToScreen) {
        renderer.setRenderTarget(null);
        this.copyFsQuad.render(renderer);
      } else {
        renderer.setRenderTarget(writeBuffer);
        if (this.clear) renderer.clear();
        this.copyFsQuad.render(renderer);
      } // Swap buffers.


      var temp = this.textureOld;
      this.textureOld = this.textureComp;
      this.textureComp = temp; // Now textureOld contains the latest image, ready for the next frame.
    }
  }, {
    key: "setSize",
    value: function setSize(width, height) {
      this.textureComp.setSize(width, height);
      this.textureOld.setSize(width, height);
    }
  }]);

  return AfterimagePass;
}(Pass);

export { AfterimagePass };